document.addEventListener('DOMContentLoaded', () => {
  // Check if menu is collapsed
  const menu = document.querySelectorAll('.js-menu-toggle');
  const menu_focus = document.querySelector('.js-menu-toggle_focus');

  function getSiblings(element) {
    const parent = element.parentNode;
    const children = Array.from(parent.children);
    return children.filter(child => child !== element);
  }

  if (menu && menu.length) {
    menu.forEach((menuEl) => {
      menuEl.addEventListener('click', () => {
        const siblings = getSiblings(menuEl);
        siblings.forEach((siblingsEl) => {
          if (!siblingsEl.classList.contains('collapsed')) {
            jQuery(siblingsEl.dataset.target).collapse('toggle');
          }
        });

        setTimeout(() => {
          if (!menuEl.classList.contains('collapsed')) {
            document.body.classList.add('no-scroll');
          } else {
            document.body.classList.remove('no-scroll');
          }
        }, 200);
      });
    });
  }

  if (menu_focus) {
    menu_focus.addEventListener('click', () => {
      setTimeout(() => {
        if (!menu_focus.classList.contains('collapsed')) {
          const searchInput = document.querySelector('.c-mobile-menu_search .c-search-input');
          if (searchInput) {
            // Use requestAnimationFrame to focus after the next frame is rendered
            requestAnimationFrame(() => {
              searchInput.focus();

              // Extra check to ensure focus on Safari
              if (document.activeElement !== searchInput) {
                searchInput.blur();
                searchInput.focus();
              }
            });
          }
        }
      }, 400);
    });
  }

  function stickIt() {
    if (!document.body.classList.contains('sticky')) {
      document.body.classList.add('sticky');
    }
  }

  function unStick() {
    if (document.body.classList.contains('sticky')) {
      document.body.classList.remove('sticky');
    }
  }

  const doc = document.documentElement;
  let lastScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  const threshold = 250;

  // Check initial position
  if (lastScrollTop >= threshold) {
    unStick();
  }

  window.addEventListener('scroll', () => {
    const st = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (st > lastScrollTop) {
      // downscroll
      if (st >= threshold) unStick();
    } else {
      // upscroll
      stickIt();
    }

    lastScrollTop = st;
  });
});



// WEBPACK FOOTER //
// ./src/scripts/modules/menu.js